import { create } from 'zustand';
import { IPractices } from '../model';

interface IPracticeState {
  practice: IPractices[];
  setPractice: (practice: IPractices[]) => void;
}

export const practiceStore = create<IPracticeState>((set) => ({
  practice: [],
  setPractice: (practice: IPractices[]) => set({ practice }),
}));
